<template>
    <div>
        <template v-if="loading">
            Loading <i class="fa fa-spinner fa-spin"></i>
        </template>
        <template v-else>
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link to="/products">Products</router-link>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">Imports</li>
                </ol>
            </nav>

            <h4 class="page-header">
                Import Products &amp; Levels
            </h4>

            <div class="row mb-4">
                <div class="col-md-8 col-12">
                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Import File:</strong>
                        </div>
                        <div class="card-body">
                            <div class="alert alert-info mb-2">
                                <strong>Note:</strong> The import file must match the format in the <a href="/files/template/Product-Import-Template.xlsx">Product-Import-Template.xlsx</a>.<br/><br/>
                                Column Headers:
                                <ul>
                                    <li>Product Name (Required)</li>
                                    <li>Product Level Name (Optional)</li>
                                    <li>Product Level Order (Required with "Product Level Name")</li>
                                    <li>
                                        Legacy Commission Names (Optional)
                                        <ul>
                                            <li>
                                                <span class="text-muted">You can entered multiple values separated with the pipe character "|". Example: "Level Name 1|Level Name 2|Level Name 3". All 3 of these values will be mapped to the Product Level Name.</span>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </div>

                            <div class="row mt-4 mb-3">
                                <div class="col-md-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.file, 'text-muted-no': !errors.file}">
                                    Import Spreadsheet: <i class="fa fa-sm fa-asterisk text-danger"></i>
                                </div>
                                <div class="col-md-6 col-12 input-group-sm">
                                    <b-form-file v-model="file" placeholder="Select the Product Import File" accept=".csv, .xls, .xlsx" />

                                    <div class="text-danger mt-1" v-if="errors.file">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors.file">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-4 col-12 mt-md-0 mt-4">

                </div>
            </div>

            <div class="mt-4">
                <button type="button" class="btn btn-sm btn-success" v-on:click="importProducts()" :disabled="saving">
                    <template v-if="saving"><i class="fas fa-spin fa-spinner"></i> Importing...</template>
                    <template v-else><i class="fas fa-save"></i> Import</template>
                </button>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: false,
                saving: false,
                file: null,
                errors: {},
            }
        },

        computed: {

        },

        methods: {

            importProducts(){
                //Helpers
                this.saving = true;

                //Send it
                this.$http
                .postWithSingleFile('products/import', {}, this.file)
                .then(response => {
                    //Alert the user?
                    this.$toastr.s('Products Imported');

                    //Return to main list?
                    this.$router.push('/products');
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data.errors;

                        //Alert
                        this.$toastr.e('Validation Errors Occurred');
                    }
                    else
                    {
                        //Alert the user
                        this.$toastr.e(error.response.data, 'Failed to Import Products');
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            },

        },

        mounted() {

        }
    }
</script>
